//const backendUrl = 'http://localhost:3005';
//const backendUrl = 'https://panel.enertech.fr:3005';
const backendUrl = 'https://paneltracker.enertech.fr:3005';
export default backendUrl;
